import { render } from "./AgenteConteo.vue?vue&type=template&id=65282be2&scoped=true"
import script from "./AgenteConteo.vue?vue&type=script&lang=ts"
export * from "./AgenteConteo.vue?vue&type=script&lang=ts"

import "./AgenteConteo.vue?vue&type=style&index=0&id=65282be2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-65282be2"

export default script